import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

const AddPublication = (props) => {

    const { schools } = useContext(SchoolContex)

    const [data, setData] = useState({
        title       : '',
        date        : '',
        description : '',
        faculty_id  : props.facultyId
    })
    const [thumb, setThumb] = useState();
    const [details, setDetails] = useState();
    const [load, setLoad] = useState(false);
    const [test, setTest] = useState(0);

    const handleInput = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        setThumb(e.target.files[0])
    }

    const handleDetails = (e) => {
        setDetails(e)
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }

    const Details = () => {
        return useMemo(() => (
            <JoditEditor
                ref={editor}
                config={config}
                value={details}
                onChange={handleDetails}
            />
        ), [test])
    }


    const saveEvent = () => {
        setLoad(true)
        // console.log(details);
        // console.log(cover);
        // console.log(thumb);
        // return;
        if (!data.title?.trim().length <= 0) {
            props.handleClose();
            Swal.fire({
                title: 'Error!',
                text: 'Title cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return ;
        }
        if (details?.length <= 0 || details === undefined) {
            props.handleClose();
            Swal.fire({
                title: 'Error!',
                text: 'Description cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return ;
        }
        const postData = new FormData();
        if (props.modalData.id) {
            postData.append('id' , props.modalData.id)
            // console.log(props.modalData.id , 'props.modalData.id');
        }
        // return;
        postData.append('title', data.title)
        postData.append('date', data.date)
        postData.append('image', thumb)
        postData.append('text', details)
        postData.append('faculty_id', props.facultyId)

        axios.post(`${process.env.REACT_APP_MAIN_API}savePublication`, postData)
            .then((res) => {
                // console.log(res);
                props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

            })
            .catch((err) => {
                // console.log(err.response);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    React.useEffect(() => {
        setData(props.modalData);
        // console.log(props.modalData, 'props.modalData');
        setDetails(props.modalData.text)
        setTest(test + 1)
        // console.log(props , 'facultyIdwww');
    }, [props.modalData])

    return (
        <>
            <div className='row'>
                <div className='col-md-12 p-2'>
                    <label>Title:</label>
                    <input type="text" className='form-control' name="title" value={data.title} onChange={handleInput} id="" />
                </div>

                <div className='col-md-4 p-2'>
                    <label>Date:</label>
                    <input type="date" className='form-control' name="date" value={data.date} onChange={handleInput} id="" />
                </div>
                <div className='col-md-4 p-2'>
                    <label>Thumbnails: </label>
                    <input type="file" className='form-control' name="thumb" onChange={handleImg} id="" />
                </div>
                <div className='col-md-4'>
                    {
                        props.modalData.image &&
                        <>
                            <label>Previous Image: </label><br/>
                            <img src={`${process.env.REACT_APP_BACKEND}publication/${props.modalData.image}`} height={60} />
                        </>
                    }
                </div>
                <div className='col-md-12 p-2'>
                    <label>Description:</label>
                    {Details()}
                </div>
                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={saveEvent}>Save Event</Button>
                </div>
            </div>
        </>
    )
}

export default AddPublication;